var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 12.625V14.5H7.375L12.905 8.97L11.03 7.095L5.5 12.625ZM14.355 7.52C14.4014 7.47374 14.4381 7.4188 14.4632 7.35831C14.4883 7.29783 14.5012 7.23299 14.5012 7.1675C14.5012 7.10202 14.4883 7.03718 14.4632 6.97669C14.4381 6.9162 14.4014 6.86126 14.355 6.815L13.185 5.645C13.1387 5.59865 13.0838 5.56188 13.0233 5.53679C12.9628 5.51169 12.898 5.49878 12.8325 5.49878C12.767 5.49878 12.7022 5.51169 12.6417 5.53679C12.5812 5.56188 12.5263 5.59865 12.48 5.645L11.565 6.56L13.44 8.435L14.355 7.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.86a45844b48149ce79b280ce8f62dddf.svg";
export { ForwardRef as ReactComponent };